import React from "react";
import { Button } from "@mui/material";
import "../css/TableButton.css";

function TableButton({ children, onClick, disabled }) {
  return (
    <Button
      variant="contained"
      className="table-button"
      color="view"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

export default TableButton;
